import { render, staticRenderFns } from "./order_release.vue?vue&type=template&id=32816a74&scoped=true&"
import script from "./order_release.vue?vue&type=script&lang=js&"
export * from "./order_release.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32816a74",
  null
  
)

export default component.exports